<div class="no-image" [class]="size()">
  {{ title() | translate }}
</div>
